/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProviderEnum } from './cloudProviderEnum';


export interface CloudProviderAccount { 
    cloud_provider?: CloudProviderEnum;
    account_id?: string;
}
export namespace CloudProviderAccount {
}


